<template>
  <div>
    <section>
      <b-col class="d-flex justify-content-between px-0 pt-25">
        <b-button
          v-b-modal.modal-add-edit-ad-formats
          variant="primary"
          :disabled="isLoading"
          size="sm"
        >
          <GjIcon
            class="mr-50"
            name="Plus"
          />
          {{ $tk('ClientPortal.Admin.DisplayAds.AddFormat') }}
        </b-button>
        <SearchInputField
          :disabled="isLoading"
          :placeholder="$tk('ClientPortal.Admin.Language.SearchPlaceholder')"
          @onInputSearch="onSearchChange"
        />
      </b-col>
      <b-card
        class="my-50"
        no-body
      >
        <div class="admin-table--smaller">
          <Table
            :data="allDisplayAds"
            class="admin-table__data"
            :columns="displayAdsColumns"
            :is-loading="isLoading"
            type-of-table="displayads"
            :enable-sort="false"
          />
          <b-modal
            id="modal-add-edit-ad-formats"
            :ok-title="$tk('ClientPortal.Form.Actions.Save')"
            cancel-variant="outline-secondary"
            :cancel-title="$tk('ClientPortal.Form.Actions.Cancel')"
            centered
            size="md"
            :ok-disabled="isFormComplete()"
            :title="$tk('ClientPortal.Filters.AdFormat')"
            no-enforce-focus
            @show="getAdFromatModel"
            @ok="save"
          >
            <b-form-group
              :label="$tk('ClientPortal.Admin.AdFormats.Name')"
              label-size="xs"
            >
              <b-form-input
                v-model="adFormatsModel.name"
                size="sm"
                type="text"
              />
            </b-form-group>
            <b-form-group
              :label="$tk('ClientPortal.Admin.AdFormats.Width')"
              label-size="xs"
            >
              <b-form-input
                v-model.number="adFormatsModel.width"
                size="sm"
                type="number"
              />
            </b-form-group>
            <b-form-group
              :label="$tk('ClientPortal.Admin.AdFormats.Height')"
              label-size="xs"
            >
              <b-form-input
                v-model.number="adFormatsModel.height"
                size="sm"
                type="number"
              />
            </b-form-group>
            <b-form-group
              :label="$tk('ClientPortal.Admin.AdFormats.MobileWidth')"
              label-size="xs"
            >
              <b-form-input
                v-model="adFormatsModel.mobileWidth"
                size="sm"
                type="number"
              />
            </b-form-group>
            <b-form-group
              :label="$tk('ClientPortal.Admin.AdFormats.MobileHeight')"
              label-size="xs"
              class="mb-0"
            >
              <b-form-input
                v-model="adFormatsModel.mobileHeight"
                size="sm"
                type="number"
              />
            </b-form-group>
          </b-modal>
        </div>
      </b-card>
    </section>

  </div>
</template>

<script>
import Table from '@/components/Table.vue'
import {
  computed, onMounted, ref,
} from '@vue/composition-api'
import store from '@/store'
import SearchInputField from '@/components/SearchInputField.vue'
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import notification from '@/mixins/toastification'
import translation from '@/mixins/translate'
import AdFormatsService from '@/api/admin/adFormats.service'

export default {
  components: {
    Table,
    SearchInputField,
    GjIcon,
  },
  mixins: [notification],

  setup() {
    const allDisplayAds = computed(() => store.getters.allDisplayAds)
    const staticColumns = [
      {
        label: translation.methods.$tk('Admin.DisplayAds.FormatName'),
        field: 'formatName',
      },
      {
        label: translation.methods.$tk('Admin.DisplayAds.FormatWidth'),
        field: 'width',
      },
      {
        label: translation.methods.$tk('Admin.DisplayAds.FormatHeight'),
        field: 'height',
      },
    ]
    const displayAdsColumns = computed(() => {
      const firstRow = allDisplayAds.value.rows?.[0]
      const subtypeColumns = (firstRow?.subtypes || []).map(subtype => ({
        label: translation.methods.$tk(`Admin.DisplayAds.${subtype.name}`),
        field: subtype.name,
        name: 'subtype',
      }))
      return [...staticColumns, ...subtypeColumns]
    })
    const isLoading = ref(false)
    const adFormatsModel = ref({})

    const getAdFromatModel = async () => {
      const adFormatId = store.getters.getAdFormatId
      adFormatsModel.value = await AdFormatsService.getAdFormat(adFormatId)
      store.commit('SET_AD_FORMAT_MODEL', { id: 0 })
    }
    const onSearchChange = async value => {
      allDisplayAds.value.searchTerm = value
    }
    const isFormComplete = () => {
      const { name, width, height } = adFormatsModel.value
      return !(name && width && height)
    }
    const save = async () => {
      try {
        const response = await AdFormatsService.updateAdFormat(adFormatsModel.value)
        if (response) {
          notification.methods.success(translation.methods.$tk('ClientPortal.Admin.ChangesHaveBeenSavedSuccesfully'))
        } else {
          notification.methods.error(translation.methods.$tk('ClientPortal.Admin.ErrorSavingChanges'))
        }
      } catch (err) {
        notification.methods.error(err.message)
      } finally {
        await store.dispatch('getDisplayAds')
      }
    }

    onMounted(async () => {
      isLoading.value = true
      await store.dispatch('getDisplayAds')
      allDisplayAds.value.searchTerm = ''
      isLoading.value = false
    })

    return {
      allDisplayAds,
      isLoading,
      adFormatsModel,
      getAdFromatModel,
      save,
      isFormComplete,
      displayAdsColumns,
      onSearchChange,
    }
  },
}
</script>
